module.exports = __webpack_public_path__ + "img/Cover.8e80ed85.jpg";